// Helper function to generate JobPosting schema data
export const generateJobPostingSchema = (jobData) => {
  if (!jobData || !jobData.job_title) return null;

  // Convert job type to schema format
  const getEmploymentType = (jobType) => {
    if (!jobType) return 'FULL_TIME';
    const type = jobType.toLowerCase();
    if (type.includes('full time') || type.includes('fulltime')) return 'FULL_TIME';
    if (type.includes('part time') || type.includes('parttime')) return 'PART_TIME';
    if (type.includes('contract')) return 'CONTRACT';
    if (type.includes('internship')) return 'INTERN';
    if (type.includes('temporary')) return 'TEMPORARY';
    return 'FULL_TIME';
  };

  // Get salary values (keep as monthly)
  const getSalaryValue = (minSalary, maxSalary) => {
    const min = minSalary || 0;
    const max = maxSalary || 0;
    // Keep salary as monthly
    return {
      minValue: min,
      maxValue: max
    };
  };

  // Convert years to months for experience
  const convertYearsToMonths = (years) => {
    if (!years || years === 0) return 0;
    return Math.round(parseFloat(years) * 12);
  };

  // Get location data
  const getLocationData = (location) => {
    if (!location) {
      return {
        addressLocality: 'Remote',
        addressRegion: 'US',
        addressCountry: 'US'
      };
    }
    
    return {
      addressLocality: location.name || 'Remote',
      addressRegion: location.state || 'US',
      addressCountry: 'IN' // Assuming India based on your data
    };
  };

  // Get valid job location type
  const getJobLocationType = (locationType) => {
    if (!locationType) return 'TELECOMMUTE';
    const type = locationType.toLowerCase();
    if (type.includes('remote') || type.includes('telecommute')) return 'TELECOMMUTE';
    if (type.includes('onsite') || type.includes('on-site')) return 'ONSITE';
    if (type.includes('hybrid')) return 'HYBRID';
    return 'TELECOMMUTE';
  };

  const salaryData = getSalaryValue(jobData.minimum_salary_per_month, jobData.maximum_salary_per_month);
  const locationData = getLocationData(jobData.location);

  return {
    title: jobData.job_title,
    description: jobData.job_responsibilities || jobData.description || `Job opportunity for ${jobData.job_title} at ${jobData.company?.name || 'JobSeekers Page'}`,
    datePosted: jobData.created_at ? new Date(jobData.created_at).toISOString() : new Date().toISOString(),
    validThrough: jobData.valid_until ? new Date(jobData.valid_until).toISOString() : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    employmentType: getEmploymentType(jobData.job_type),
    hiringOrganization: {
      name: jobData.company?.name || 'JobSeekers Page',
      url: jobData.company?.website_url || window.location.origin,
      logo: jobData.company?.logo || `${window.location.origin}/assets/images/jobseekers-logo.png`
    },
    jobLocation: {
      addressLocality: locationData.addressLocality,
      addressRegion: locationData.addressRegion,
      addressCountry: locationData.addressCountry
    },
    applicantLocationRequirements: {
      name: jobData.applicant_location_requirements || 'India'
    },
    baseSalary: {
      currency: 'INR',
      minValue: salaryData.minValue,
      maxValue: salaryData.maxValue,
      unitText: 'MONTH'
    },
    jobLocationType: getJobLocationType(jobData.job_location_type),
    url: jobData.url || window.location.href,
    // Additional fields for better SEO
    qualifications: jobData.qualifications_required,
    experienceRequirements: {
      minExperience: convertYearsToMonths(jobData.minimum_experience_required),
      maxExperience: convertYearsToMonths(jobData.maximum_experience_required)
    },
    numberOfVacancies: jobData.total_number_of_vacancies || 1,
    skills: jobData.skills_and_experience,
    keywords: jobData.search_keywords
  };
};
  
  // Helper function to generate JobPosting schema for job listings page
export const generateJobListingsSchema = () => {
  return {
    title: "Job Listings - Find Your Dream Job",
    description: "Browse thousands of job opportunities across different industries and locations. Find your dream job with advanced search and filtering options.",
    datePosted: new Date().toISOString(),
    validThrough: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    employmentType: "FULL_TIME",
    hiringOrganization: {
      name: "JobSeekers Page",
      url: window.location.origin,
      logo: `${window.location.origin}/assets/images/jobseekers-logo.png`
    },
    jobLocation: {
      addressLocality: "Remote",
      addressRegion: "IN",
      addressCountry: "IN"
    },
    applicantLocationRequirements: {
      name: "India"
    },
    baseSalary: {
      currency: "INR",
      minValue: 0,
      maxValue: 0,
      unitText: "MONTH"
    },
    jobLocationType: "TELECOMMUTE",
    url: window.location.href
  };
};